<template>
  <div class="manual-payments">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <!-- <artmisads-segmented-tabs v-model="activeTab" :items="programConfig" :disabled="load" @change="onTabChange" /> -->
    <div class="filters">
      <div class="search">
        <!-- <div class="option">
          <span>Username</span>
          <artmisads-select :clearable="true" show-search v-model:value="filters.sellerId" style="width: 232px"
            :options="sellerOptions" @search="searchSeller" :show-arrow="false" :filter-option="false"
            :not-found-content="null" @change="handleChangeSeller" placeholder="All" allowClear />
        </div> -->
        <div class="option" ref="marketplaceRef">
          <span>Marketplace</span>
          <!-- <artmisads-input v-model:value="filters.marketplace" @press-enter="getPartData({})"
            placeholder="Enter Marketplace"></artmisads-input> -->
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.marketplace"
            :getPopupContainer="() => $refs.marketplaceRef" :options="COUNTRY_BASE_OPTIONS" />
        </div>
        <!-- <div class="option">
          <span>Email</span>
          <artmisads-input v-model:value="filters.email" 
            placeholder="Enter Email" :allowClear="true"></artmisads-input>
        </div> -->
        <!-- <div class="option">
          <span>Brand</span>
          <artmisads-select :clearable="true" show-search v-model:value="filters.brandId" style="width: 232px"
            :options="brandOptions" @search="searchBrand" :show-arrow="false" :filter-option="false"
            :not-found-content="null" placeholder="All" allowClear />
        </div> -->
        <!-- <div class="option" ref="submitTimeToRef">
          <span>上传时间</span>
          <artemisads-range-picker :clearable="true" format="YYYY-MM-DD" v-model:value="filters.executedAtEnd"
            style="width: 232px" />
        </div> -->
        <div class="option">
          <span>Publisher</span>
          <artmisads-select :clearable="true" show-search v-model:value="filters.publisherId" style="width: 232px"
            :options="publisherOptions" @search="searchPublisher" :show-arrow="false" :filter-option="false"
            :not-found-content="null" placeholder="All" allowClear />
        </div>
        <div class="option" ref="statusRef">
          <span>上传时间</span>
          <artemisads-range-picker :clearable="true" format="YYYY-MM-DD" v-model:value="filters.uploadTime"
            style="width: 232px" />
        </div>

        <div class="option" ref="typeStatusRef">
          <span>清洗状态</span>
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.status"
            :getPopupContainer="() => $refs.typeStatusRef" :options="STATUS_OPTIONS" />
        </div>
        <!-- <div class="option" ref="changeToRef">
          <span>ChangeTo</span>
          <artmisads-select :clearable="true" style="width: 232px" v-model:value="filters.operationCategory"
            :getPopupContainer="() => $refs.changeToRef" :options="CHANGE_OPTIONS" />
        </div> -->
        <!-- <div class="option" ref="submitTimeToRef">
          <span>SubmitTimeTo</span>
          <artemisads-range-picker :clearable="true" format="YYYY-MM-DD" v-model:value="filters.executedAtEnd"
            style="width: 232px" />
        </div> -->
        <!-- <div class="option" v-if="activeTab=='1'">
          <span>ASIN</span>
           <artmisads-input v-model:value="filters.asin" 
            placeholder="Enter ASIN"></artmisads-input>
        </div> -->
      </div>

    </div>
    <div class="button">
      <artmisads-button isSquare="true" type="primary" style="margin-right: 12px" :loading="load"
        @click="searchList">Search</artmisads-button>
      <artmisads-button isSquare="true" @click="onReset">Reset</artmisads-button>
    </div>

    <div class="table-data">
      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="dataList"
        :change="onTableChange" :loading="load" :scroll="{ x: 1600, y: tableScrollHeight }">
        <template #bodyCell="{ record, index, column }">
          <template v-if="column.key === 'uploadTime'">
            {{ returnUploadTime(record) }}
          </template>
          <template v-if="column.key === 'perlod'">
            {{ record.reportStartDate }}~{{ record.reportEndDate }}
          </template>
          <template v-if="column.key === 'status'">
            {{ statusMapper[record.status] }}
          </template>
          <template v-if="column.key === 'action'">
            <artmisads-select-button isSquare="true" @click="cleanData(record)">重新清洗</artmisads-select-button>
          </template>
        </template>

      </artmisads-table>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue'
import breadcrumbs from '../../breadcrumbs.vue'
import { COUNTRY_BASE } from '~/contants/common'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'

import { sellerLogsApi } from '~/server/operator/sellerLogs'

import moment from 'moment'

import { publisherAdminApi } from '~/server/index'
import { useUserInfoStore } from '@/storeData'

import { COUNTRY_TIME_TZ } from '~/contants/common.js'
const statusMapper = {
  processing: '文件上传成功，csv 数据处理中',
  success: 'csv 数据处理成功',
  failed: 'csv 数据处理失败',
  cleaning: '数据清洗中',
  clean_success: '数据清洗成功',
  clean_failed: '数据清洗失败'
}
const STATUS_OPTIONS = [
  {
    label: 'All',
    value: ''
  },
  {
    label: '文件上传成功，csv 数据处理中',
    value: 'processing'
  },
  {
    label: 'csv 数据处理成功',
    value: 'success'
  },
  {
    label: 'csv 数据处理失败',
    value: 'failed'
  },
  {
    label: '数据清洗中',
    value: 'cleaning'
  },
  {
    label: '数据清洗成功',
    value: 'clean_success'
  },
  {
    label: '数据清洗失败',
    value: 'clean_failed'
  }
]
import { CURRENCY_MAPPER, COUNTRY_SITE_CODE_MAP } from '~/contants/common'
import { message } from 'ant-design-vue'




const columns = ref([
  {
    title: 'UploadTime',
    key: 'uploadTime',
    dataIndex: 'uploadTime',
    align: 'center',
  },
  {
    title: 'Marketplace',
    dataIndex: 'marketplace',
    key: 'marketplace',
    align: 'center',
  },
  {
    title: 'Publisher',
    dataIndex: 'publisherName',
    key: 'publisherName',
    align: 'center',
  },
  {
    title: '文件名',
    dataIndex: 'uploadFileName',
    key: 'uploadFileName',
    align: 'center',
  },
  {
    title: '上传记录数',
    dataIndex: 'totalRows',
    key: 'totalRows',
    align: 'center',
  },
  {
    title: 'Perlod',
    dataIndex: 'perlod',
    key: 'perlod',
    align: 'center',
  },
  {
    title: '清洗状态',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
  },
  {
    title: 'action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
  }
])
const user = useUserInfoStore()
const countryCode = user?.userInfo?.countryCode || 'US'
const marketplace = CURRENCY_MAPPER[countryCode].host
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode || 'US']

const dataList = ref([])

const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
})

const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350,
})
const load = ref(false)

const breadcrumbsData = ref({
  title: 'Seller Logs - AssociateReports',
  des: '',
  links: [
    {
      name: 'Home',
      path: '/operator/users',
    },
    {
      name: 'Operation',
      path: '/operator/operation/manualPayments',
    },
    {
      name: 'SellerLogs',
      path: '/operator/operation/sellerLogs/attribution',
    },
    {
      name: 'AssociateReports',
      path: '/operator/operation/sellerLogs/associateReports',
    },
  ],
})

const filters = ref({
  marketplace: 'amazon.com',
  status: '',
  publisherId: '',

})

const publisherOptions = ref([])

const returnUploadTime = (record) => {
  return `${moment(Number(record?.uploadAt)).tz(timezone).format('YYYY-MM-DD HH:mm:ss')}`
}

const searchPublisher = async keyword => {
  const params = {
    keyword,
    marketplace: marketplace
  }
  let data = await publisherAdminApi.searchPublisher(params)
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id
      item.label = item.creatorName
      return item
    })
    publisherOptions.value = data
  }
}
const searchList = async () => {

  pagination.current = 1
  getData(filters.value)
}


const onReset = () => {
  filters.value = {
    marketplace: 'amazon.com',
    status: '',
    publisherId: '',
  }
  getData({})
}
const onTableChange = ({ current, pageSize }) => {
  // console.log(current, pageSize,'数据')
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getData({ page: current, size: pageSize })
}
const getData = async (params) => {
  load.value = true
  if (Object.keys(params).length === 0) {
    pagination.current = 1
  }
  let _params = {
    page: pagination.current,
    size: pagination.size,
    ...filters.value,

    // marketplace: filters.marketplace,
    // sellerId: filters.sellerId,
    // bd: filters.bd
  }

  if (_params.uploadTime) {
    const startDate = params.uploadTime[0].format('YYYY-MM-DD')+' 00:00:00'
    const endDate = params.uploadTime[1].format('YYYY-MM-DD')+' 23:59:59'
    _params.uploadStartTimestamp = moment(startDate).valueOf()
    _params.uploadEndTimestamp = moment(endDate).valueOf()
  }

  let newparams = { ..._params }
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ''
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {})
  // console.log(activeTab.value,'activeTab.value')
  sellerLogsApi
    .getSellerAssociateReportBatchList(newparams)
    .then((res) => {

      if (res.success) {
        dataList.value = res.data.data
        pagination.total = res.data.total
      }
    })
    .finally(() => {
      load.value = false
    })

}
const cleanData = async (record) => {
  sellerLogsApi
    .cleanSellerAssociateReportBatch({
      id: record.id
    })
    .then((res) => {
      if (res.success) {
        message.success('清洗成功')
        getData({})
      }else{
        message.error(res.error || '清洗失败')
      }
    })
    .finally(() => {
      load.value = false
    })
}
getData({})
// onMounted(() => {
//   getData({})
// })
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
</script>
<style scoped lang="less">
.button {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  justify-content: flex-end;
}

.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-search-input) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-placeholder) {
    line-height: 32px !important;
  }
}

.add {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
  gap: 12px;
}

.manual-payments {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}

.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .option {
      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}
</style>
